<template>
  <div class="about-side-bar">
    <div class="title">
      客户<br />服务
    </div>
    <div class="side-nav">
      <div v-for="(item, index) in navData" :key="index" @click="switchNav(item.class, index)" :class="[currentNav === item.class ? 'active' : '',index + 1 === currentIndex ? 'activePrev' : '', 'nav-item']">
        <div>{{item.name}}</div>
        <img v-if="item.class == currentNav" src="../../assets/img/aboutus/more_active.png" alt="">
        <img v-else src="../../assets/img/aboutus/more.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentIndex: 0,
      currentNav: 'agreement',
      navData: [
        { name: '经纪服务委托协议', class: 'agreement' },
        { name: '客户告知书', class: 'notification' },
        { name: '特色服务', class: 'special' },
        { name: '保单服务', class: 'policy' },
      ]
    }
  },
  created () {
    // console.log(this.$route.name)
    this.currentNav = this.$route.name
    this.$emit('pageName', this.currentNav)
    let _this = this
    this.navData.forEach((item, index) => {
      if (item.class == _this.currentNav) {
        _this.currentIndex = index
      }
    }) 
  },
  watch:{
    $route(to){
      if (to.name != 'Detail') {
        this.currentNav = to.name
      }
      
    }
  },
  methods: {
    // 导航切换
    switchNav (nav, index) {
      this.currentIndex = index
      document.body.scrollTop=document.documentElement.scrollTop=0
      this.currentNav = nav
      this.$emit('loading', true)
      if (this.$route.name != nav) {
        this.$router.push({path: '/customerService/' + nav })
      }   
      this.$emit('pageName', nav)
    }
  }
}
</script>
<style lang="scss" scoped>
.about-side-bar {
  // position: fixed;
  // top: 5rem;
  white-space: nowrap;
  width: 3rem;
  height: auto;
  margin-right: .57rem;
  .title {
    width: 100%;
    height: 1.1rem;
    background-image: url(../../assets/img/aboutus/nav.png);
    background-size: 100% 100%;
    font-size: 0.3rem;
    color: #ffffff;
    box-sizing: border-box;
    padding: .19rem .24rem 0;
    line-height: 1.3;
  }
  .side-nav {
    width: 100%;
    .nav-item {
      background-color: #ffffff;
      width: 100%;
      display: flex;
      height: .55rem;
      justify-content: space-between;
      align-items: center;
      font-size: .18rem;
      color: #333333;
      box-sizing: border-box;
      padding: 0 0.2rem;
      border-bottom: 1px solid #DCDCDC;
      cursor: pointer;
      &:hover {
        background-color: #FFF8EC;
        color: #FF6004;
        border-color:rgba(255, 168, 41, .1);
      }
      &.activePrev {
        border-bottom: 1px solid rgba(255, 168, 41, 0);
      }
      &.active {
        background-color: #FFF8EC;
        color: #FF6004;
        border-color: rgba(255, 168, 41, .1);
        position: relative;
        &::after {
          display: block;
          content: "";
          height: 100%;
          width: 0.04rem;
          background-color: #FF6004;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
    img {
      width: 0.06rem;
      height: 0.1rem;
    }
  }
}
</style>